import Icon from '../components/Icon';

const CellSignalNone = Icon(
  'cell-signal-none',
  <>
    <path d="M3.875 18.5c.483 0 .875.392.875.875v.75a.875.875 0 0 1-1.75 0v-.75c0-.483.392-.875.875-.875M7.875 14.75c.483 0 .875.392.875.875v4.5a.875.875 0 0 1-1.75 0v-4.5c0-.483.392-.875.875-.875M11.875 11c.483 0 .875.392.875.875v8.25a.875.875 0 0 1-1.75 0v-8.25c0-.483.392-.875.875-.875M19.506 15.006a.876.876 0 0 1 1.238 1.238l-1.63 1.631 1.63 1.63a.876.876 0 0 1-1.238 1.24l-1.631-1.632-1.63 1.631a.876.876 0 0 1-1.24-1.238l1.632-1.631-1.631-1.63a.876.876 0 0 1 1.238-1.24l1.631 1.632zM15.875 7.25c.483 0 .875.392.875.875v3.75a.875.875 0 0 1-1.75 0v-3.75c0-.483.392-.875.875-.875M19.875 3.5c.483 0 .875.392.875.875v7.5a.875.875 0 0 1-1.75 0v-7.5c0-.483.392-.875.875-.875" />
  </>
);

export default CellSignalNone;
